import { ACTIONS_TYPES } from "../Reducers/annotationsCommentReducer";

export const getAnnotationsCommentAction = (commentData) => {
    return {
      type: ACTIONS_TYPES.GET_ANNOTATIONS_COMMENT,
      payload: commentData,
    };
  };
